import PropTypes from "prop-types";
import { SORTING } from "../../constants/sorting";

const SortingTypes = PropTypes.oneOf([
	SORTING.TYPES.DATE,
	SORTING.TYPES.NUMBER,
	SORTING.TYPES.STRING,
	SORTING.TYPES.ANY,
	SORTING.TYPES.BOOLEAN
]);

const SortingDirections = PropTypes.oneOf([
	SORTING.DIRECTIONS.ASC,
	SORTING.DIRECTIONS.DESC
]);

const Align = PropTypes.oneOf(["left", "right", "center"]);

export const ROW_SELECTION_PROP_TYPES = {
	Align,
	SortingTypes: SortingTypes,
	SortingDirections,
	CustomSortingLabels: PropTypes.objectOf(SortingDirections),
	Columns: PropTypes.arrayOf(
		PropTypes.shape({
			key: PropTypes.string.isRequired,
			align: Align,
			render: PropTypes.func,
			preferredSortingType: SortingTypes,
			customSortingLabels: PropTypes.objectOf(SortingDirections),
			sortable: PropTypes.bool,
			width: PropTypes.string
		})
	),
	RowSelection: PropTypes.shape({
		selected: PropTypes.arrayOf(PropTypes.any),
		onChangeSelection: PropTypes.func
	})
};
